import _ from 'lodash'
import { ErrorReportStatus } from '../ErrorReportContext'

export const renderReportStatus = (status = ErrorReportStatus.NORMAL.value) => {
  const { icon, label, component } = _.find(ErrorReportStatus, { value: status }) ?? {}
  return component ?? null
}

export const renderIconReportStatus = (status = ErrorReportStatus.NORMAL.value) => {
  const { icon, label, component } = _.find(ErrorReportStatus, { value: status }) ?? {}
  return icon ?? null
}
